<div id="main-content" class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <div data-drupal-messages-fallback="" class="hidden"></div>
                <h1 class="page-header">
                    <span>{{ 'INTENT_HEADING' | translate }}</span>
                </h1>
        </div>
        </div>
    </div>
</div>

<div role="main" class="main-container container js-quickedit-main-content">
    <div class="row">
        <section class="col-sm-9">
            <div class="region region-content">
                <article data-history-node-id="2" class="page full clearfix">
                    <div class="content">
                        <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p class="big green"><strong>{{ 'INTENT_TITLE' | translate }}</strong></p>
                            <p>{{ 'INTENT_BODY1' | translate }}</p> 
                            <p>{{ 'INTENT_BODY2' | translate }}&nbsp;<a routerLink="/lessees-faq">{{ 'INTENT_BODY3' | translate }} </a> {{ 'INTENT_BODY4' | translate }} <a routerLink="/contact-us">{{ 'INTENT_BODY5' | translate }}</a>.</p>
                        </div>
                    </div>
                </article>
            </div>

            <form class="custom-from" #customerIntentForm="ngForm" (ngSubmit)="saveCustomerIntent(customerIntentForm)" novalidate style="background-color: #f8f7f7; padding: 20px; margin-top: 25px;">
                <p style="font-weight:bold;">{{ 'INTENT_FORM_TITLE' | translate }}</p>

                <div class="form-group">
                    <section>{{ 'INTENT_FORM_LAST_NAME' | translate }} <label style="color:red;"> * </label></section>
                    <section>
                        <input type="text" 
                            class="form-control" 
                            id="lastName" name="lastName" 
                            [(ngModel)]="customer.lastName"   
                            [ngClass]="{ 'is-invalid': formSubmitted && customerIntentForm.controls.lastName.errors }"                                         
                            required maxlength="100"/>
                    </section>
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_FIRST_NAME' | translate }}</section>
                    <section>
                        <input type="text" 
                            class="form-control" 
                            id="firstName" name="firstName" 
                            [(ngModel)]="customer.firstName"   
                            [ngClass]="{ 'is-invalid': formSubmitted && customerIntentForm.controls.firstName.errors }"                                            
                            maxlength="100"/>
                    </section>           
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_EMAIL' | translate }} <label style="color:red;"> * </label></section>
                    <section>
                        <input type="text" 
                            class="form-control" 
                            id="emailAddress" name="emailAddress" 
                            [(ngModel)]="customer.emailAddress"   
                            [ngClass]="{ 'is-invalid': formSubmitted && customerIntentForm.controls.emailAddress.errors }"                                            
                            [pattern]="emailPattern" required maxlength="250"/>
                    </section>
                    <div *ngIf="formSubmitted && customerIntentForm.form.controls.emailAddress.invalid" style="color:red;">
                        <div *ngIf="customerIntentForm.form.controls.emailAddress.errors.pattern">{{ 'INTENT_FORM_EMAIL_INVALID' | translate }}</div>
                    </div>     
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_PHONE' | translate }} <label style="color:red;"> * </label></section>
                    <div style="font-size:12px">{{ 'INTENT_FORM_PHONE_NOTE' | translate }}</div>
                    <section>
                        <input type="text" 
                            class="form-control" 
                            id="phoneNumber" name="phoneNumber" 
                            placeholder="XXXXXXXXXX" 
                            [(ngModel)]="customer.phoneNumber"   
                            [ngClass]="{ 'is-invalid': formSubmitted && customerIntentForm.controls.phoneNumber.errors }"                                            
                            (input)="phoneValidator($event)" [pattern]="phonePattern" required maxlength="50"/>
                    </section>               
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_VIN' | translate }} <label style="color:red;"> * </label></section>
                    <section>
                        <input type="text" 
                            class="form-control" 
                            id="vin" name="vin" 
                            placeholder="{{ 'INTENT_FORM_VIN' | translate }}" 
                            [(ngModel)]="customer.vin"   
                            [ngClass]="{ 'is-invalid': formSubmitted && (customerIntentForm.controls.vin.errors || (customer.leaseNumber=='' && customer.vin=='')) }"                                           
                            [pattern]="vinPattern" maxlength="17"/>
                    </section>                 
                    <div style="font-size:12px">{{ 'INTENT_FORM_VIN_NOTE' | translate }}</div>
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_LEASE_END_OPTIONS' | translate }} <label style="color:red;"> * </label></section>
                    <section style="margin-left:20px;">
                        <div class="row" style="margin-top:5px;"><input type="radio" name="leaseEndOption" value="Purchase vehicle" [(ngModel)]="customer.leaseEndOption"> {{ 'INTENT_FORM_PURCHASE_VEHICLE' | translate }} </div>
                        <div class="row" style="margin-top:5px;"><input type="radio" name="leaseEndOption" value="Return vehicle" [(ngModel)]="customer.leaseEndOption"> {{ 'INTENT_FORM_RETURN_VEHICLE' | translate }} </div>
                        <div class="row" style="margin-top:5px;"><input type="radio" name="leaseEndOption" value="Other" [(ngModel)]="customer.leaseEndOption" required> {{ 'INTENT_FORM_OTHER' | translate }} </div>
                    </section>
                    <div *ngIf="formSubmitted && customerIntentForm.form.controls.leaseEndOption.invalid" style="color:red;">
                        <div *ngIf="customerIntentForm.controls.leaseEndOption.errors.required">{{ 'INTENT_FORM_REQUIRED' | translate }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_LEASE_END_OPTIONS_OTHER' | translate }}</section>
                    <input type="text" class="form-control" id="otherOption" name="otherOption" [(ngModel)]="customer.otherOption" [ngClass]="{ 'is-invalid': formSubmitted && customer.leaseEndOption=='Other' && customer.otherOption=='' }" maxlength="100"/>
                    <div *ngIf="formSubmitted && customerIntentForm.form.controls.otherOption.invalid" style="color:red;">
                        <div *ngIf="customerIntentForm.form.controls.otherOption.errors.maxlength">{{ 'INTENT_FORM_TOO_LONG' | translate }}</div>
                    </div>
                    <div *ngIf="customer.leaseEndOption=='Other'">
                        <div style="font-size:12px">{{ 'INTENT_FORM_LEASE_END_OPTIONS_OTHER_DISCLAIMER' | translate }}</div>
                    </div>			
                </div>
                <div class="form-group">
                    <section>{{ 'INTENT_FORM_CONTACT_DEALER' | translate }} <label style="color:red;"> * </label></section>
                    <div style="margin-left:20px;">
                        <div class="row" style="margin-top:5px;"><input type="radio" name="contacted" value="Yes" [(ngModel)]="customer.contacted"> {{ 'INTENT_FORM_YES' | translate }} </div>
                        <div class="row" style="margin-top:5px;"><input type="radio" name="contacted" value="No" [(ngModel)]="customer.contacted" required> {{ 'INTENT_FORM_NO' | translate }} </div>
                    </div>
                    <div *ngIf="formSubmitted && customerIntentForm.form.controls.contacted.invalid" style="color:red;">
                        <div *ngIf="customerIntentForm.controls.contacted.errors.required">{{ 'INTENT_FORM_REQUIRED' | translate }}</div>
                    </div>
                </div>
                <div class="row" style="margin-top:10px; margin-bottom:5px;">
                    <div class="col-md-12">
                        <button type="submit" style="background-color: #078488; color:white;" class="btn btn-block btn-primary" [disabled]="isSubmitted"><strong>{{ 'INTENT_FORM_SUBMIT' | translate }}</strong></button>
                    </div>
                </div>
            </form>
            <div *ngIf="formSubmitted && (customerIntentForm.invalid || (customer.leaseNumber=='' && customer.vin=='') || (customer.leaseEndOption=='Other' && customer.otherOption==''))" class="row" style="margin: auto;">
                <div class="col-sm-12" style="width:100%; text-align:center; font-weight:bold; color:red">
                    <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                </div>
            </div>
        </section>
        <aside class="col-sm-3">
            <div class="region region-sidebar-second">
                <section id="block-aboutussidebar" class="block block-block-content clearfix">
                    <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item"><h2 class="red">{{ 'QUICK_LINKS' | translate }}</h2>
                        <ul class="no-bullets">
                            <li><a routerLink="/about-us">{{ 'QUICK_LINKS_ABOUT_US' | translate }}</a></li>
                            <li class="hide-faq-link"><a routerLink="/lessees-faq">{{ 'QUICK_LINKS_FAQ' | translate }}</a></li>
                            <li><a routerLink="/contact-us">{{ 'QUICK_LINKS_CONTACT_INFO' | translate }}</a></li>
                        </ul>
                    </div>     
                </section>
            </div>
        </aside>
    </div>
</div>
